import React, { useEffect, useState } from "react";
import LibraryPropsBox from "./LibraryPropsBox";
import OpenLibraryQuestion from "./OpenLibraryQuestion";
import axios from "../../axios";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@mui/material";
import { grey, orange } from "@mui/material/colors";

const SelectFromLibr = ({
  setClick1,
  setQuestions,
  assessmentDetails,
  questions,
  getquestiondata,
  sourceLibrary,
  componentType,
  setOpenQuestionBox,
  sourceQsBank,
  selectedBox,
}) => {
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const [click, setClick] = useState(false);
  const [selQueID, setSelQueID] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [qsBankNameData, setQsBankNameData] = useState([]);
  const [hideSelectBox, setHideSelectBox] = useState(false);
  const [filter, setFilter] = useState({
    standard: assessmentDetails?.standard_id,
    section: assessmentDetails?.section_id,
    subject: assessmentDetails?.subject_id,
    skill: null,
    domain: null,
    bookChapter: null,
    difficultyLevel: null,
    limit: Infinity,
    qsBankNameData: null,
    page: 1,
  });
  const [chaptersDataToPass, setChaptersDataToPass] = useState([]);
  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const domainsData = useSelector((state) => state.initialData.domain);
  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    domains: domainsData,
    chapters: null,
    difficultyLevels: difficulty_levelData,
    QsBankNameList: qsBankNameData,
  });
  const { skills, domains, chapters, difficultyLevels, QsBankNameList } =
    dropdownList;

  const [selectedQuestion, setSelectedQuestion] = useState([]);
  const [libraryQuestions, setLibraryQuestions] = useState([]);
  const [isInProgress, setIsInProgress] = useState(false);
  const isCheckedQsBank = JSON.parse(localStorage.getItem("isCheckedQsBank"));
  const [questionTypeByB4STypeId, setQuestionTypeByB4STypeId] = useState({});
  const [questionTypeMap, setQuestionTypeMap] = useState({});

  useEffect(() => {
    let b4sQuestionTypes = {};

    Object.values(questionTypeMap).map((val) => {
      if (
        val.b4sQuestionType !== undefined &&
        b4sQuestionTypes[val.b4sQuestionType] === undefined
      ) {
        b4sQuestionTypes[val.b4sQuestionType] = val;
      }
    });
    setQuestionTypeByB4STypeId(b4sQuestionTypes);
  }, [questionTypeMap]);

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`,
      );

      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
      setChaptersDataToPass((prev) => [...prev, ...chapters.data.data]);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(dropdownList, "dropdownList");

  useEffect(() => {
    getDetails();
  }, []);

  const getQuestionBankNameList = async (isCheckedQsBank) => {
    setHideSelectBox(isCheckedQsBank);
    setLibraryQuestions([]);
    setSelectedQuestion([]);
    localStorage.setItem("isCheckedQsBank", JSON.stringify(isCheckedQsBank));
    // handleResetField(isCheckedQsBank)
    if (isCheckedQsBank) {
      try {
        let res = await axios.get(
          `/api/v1/questionBank/getBySubjectId?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}`,
        );
        res &&
          setDropdownList((prev) => ({
            ...prev,
            QsBankNameList: res.data.data,
          }));
        // setQsBankNameData(res.data.data)
      } catch (error) {
        console.log("error", error);
      }
    } else {
      setFilter({
        standard: assessmentDetails?.standard_id,
        section: assessmentDetails?.section_id,
        subject: assessmentDetails?.subject_id,
        skill: null,
        domain: null,
        bookChapter: null,
        difficultyLevel: null,
        limit: Infinity,
        qsBankNameData: null,
        page: 1,
      });
      setSelectedQuestion([]);
      for (const que of selQueID) {
        localStorage.removeItem(`isChecked_${que}`);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && selectedQuestion.length >= 1) {
        setClick(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedQuestion, setClick]);

  const handleAddingQuestion = (isChecked, customQuestion = null) => {
    const q = customQuestion; // 🔥 reuse logic

    if (isChecked) {
      // 🔥 Helper to extract subjective_evaluation safely
      const getSubjectiveEval = (questionData) => {
        const isManuallyGraded =
          questionData?.type?.is_manually_graded === true ||
          questionData?.type_id?.isManuallyGraded === true;

        if (!isManuallyGraded) return undefined; // MCQ ke liye nahi chahiye

        // Agar library question mein AI data hai toh use karo
        if (questionData?.subjective_evaluation) {
          return {
            enabled: questionData.subjective_evaluation.enabled || false,
            expectedAnswer:
              questionData.subjective_evaluation.expectedAnswer || "",
            rubric: questionData.subjective_evaluation.rubric || [],
          };
        }

        // Agar nahi hai, toh default empty init karo
        return {
          enabled: false,
          expectedAnswer: "",
          rubric: [],
        };
      };

      if (sourceLibrary === SourceLibrary.FROM_AI_LIBRARY) {
        setSelectedQuestion((prev) => [
          ...prev,
          {
            standard_id: q?.standard?.id,
            subject_id: q?.subject?.id,
            section_id: q?.section?.id,
            book_id: q?.book?.id,
            chapter_id: q?.chapter?.id,
            type_id: q?.type?.id,
            question_type: q?.type?.is_manually_graded ? "true" : "false",
            domain_id: q?.domain?.id,
            skill_id: q?.skill?.id,
            difficulty_level: q?.difficulty_level?.id,
            title: q?.title,
            correct_score: q?.correct_score,
            is_mandatory: q?.is_mandatory,
            add_to: "all",
            add_to_mock: false,
            attachments: q?.attachments,
            options: q?.options,
            correct_answers: q?.correct_answers,
            is_question_edited: false,
            question: q,
            // 🔥 AI Data add karo
            ...(getSubjectiveEval(q) && {
              subjective_evaluation: getSubjectiveEval(q),
            }),
          },
        ]);
      }

      const isDup = selectedQuestion.some((que) => que.id === q.id);
      if (!isDup) {
        if (sourceLibrary == SourceLibrary.FROM_SCHOOL_LIBRARY) {
          setSelQueID((prev) => [...prev, q.id]);

          setSelectedQuestion((prev) => [
            ...prev,
            {
              id: q?.id,
              standard_id: q?.standard?.id || q?.standard_id?.id,
              subject_id: q?.subject?.id || q?.subject_id?.id,
              section_id: q?.section?.id || q?.section_id?.id,
              book_id: q?.book?.id || q?.book_id?.id,
              chapter_id: q?.chapter?.id || q?.chapter_id?.id,
              type_id: q?.type?.id || q?.type_id?.id,
              question_type:
                q?.type?.is_manually_graded === true ||
                q?.type_id?.isManuallyGraded === true
                  ? "true"
                  : "false",
              domain_id: q?.domain?.id || q?.domain_id?.id,
              skill_id: q?.skill?.id || q?.skill_id?.id,
              difficulty_level: q?.difficulty_level?.id,
              title: q?.title,
              correct_score: q?.correct_score,
              is_mandatory: q?.is_mandatory,
              add_to: "all",
              add_to_mock: false,
              attachments: q?.attachments,
              options: q?.options,
              correct_answers: q?.correct_answers,
              is_question_edited: false,
              question: q,
              // 🔥 AI Data add karo
              ...(getSubjectiveEval(q) && {
                subjective_evaluation: getSubjectiveEval(q),
              }),
            },
          ]);
        } else if (sourceLibrary == SourceLibrary.FROM_B4S_LIBRARY) {
          if (!questionTypeByB4STypeId[q?.type?.id]?.id) {
            return;
          }

          setSelQueID((prev) => [...prev, q.id]);

          setSelectedQuestion((prev) => [
            ...prev,
            {
              b4sQuestion: q?.id,
              standard_id: assessmentDetails?.standard_id?.id,
              subject_id: assessmentDetails?.subject_id?.id,
              section_id: assessmentDetails?.section_id?.id,
              book_id: q?.book?.id,
              chapter_id: q?.chapter?.id,
              type_id: questionTypeByB4STypeId[q?.type?.id]?.id,
              question_type: q?.type?.is_manually_graded ? "true" : "false",
              domain_id: q?.domain?.id,
              skill_id: q?.skill?.id,
              difficulty_level: q?.difficulty_level?.id,
              title: q?.title,
              correct_score: q?.correct_score,
              is_mandatory: q?.is_mandatory,
              add_to: "all",
              add_to_mock: false,
              attachments: q?.attachments,
              options: q?.options,
              correct_answers: q?.correct_answers,
              is_question_edited: false,
              question: q,
              // 🔥 AI Data add karo
              ...(getSubjectiveEval(q) && {
                subjective_evaluation: getSubjectiveEval(q),
              }),
            },
          ]);
        }
      }
    }
  };

  return (
    <>
      {!click && (
        <div className="library_transprant_body rounded-3">
          <div className="library_container rounded-3">
            <img
              src="/images/cross-circle3.svg"
              className="library_close_btn_hw"
              alt=""
              onClick={(e) => {
                setClick1(false);
                for (const que of selQueID) {
                  localStorage.removeItem(`isChecked_${que}`);
                }
              }}
            />
            <div
              className="p-4"
              style={{ backgroundColor: "#fee3b8", width: "100%" }}
            >
              <div className="d-flex justify-content-between">
                <span className="select_library_header">
                  {sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY ? (
                    <img
                      src="/images/Picture1.png"
                      alt="icon"
                      style={{ width: "28px", marginRight: "8px" }}
                    />
                  ) : (
                    <img
                      src="/images/Picture2.png"
                      alt="icon"
                      style={{ width: "25px", marginRight: "8px" }}
                    />
                  )}
                  Select From
                  {sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY
                    ? " School Library"
                    : " B4S Library"}
                </span>
                {sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY && (
                  <span>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: grey[500],
                            "&.Mui-checked": {
                              color: orange[800],
                            },
                          }}
                          checked={hideSelectBox}
                          onChange={(e) =>
                            getQuestionBankNameList(e.target.checked)
                          }
                        />
                      }
                      label="Select from Question Bank"
                    />
                  </span>
                )}
                <span className="library_selected_count">
                  Selected ({selectedQuestion.length})
                </span>
              </div>

              <div className="d-flex gap-3 mt-4">
                <div className="hw_default_dropdown_card">
                  <small className="poppins-semibold">CLASS</small>
                  <span className=" hw_default_dropdown_box_size">
                    {assessmentDetails?.standard_id?.name}
                  </span>
                </div>

                <div className="hw_default_dropdown_card">
                  <small className="poppins-semibold">SECTION</small>
                  <span className=" hw_default_dropdown_box_size">
                    {assessmentDetails?.section_id?.name}
                  </span>
                </div>

                <div className="hw_default_dropdown_card">
                  <small className="poppins-semibold">SUBJECT</small>
                  <span className=" hw_default_dropdown_box_size">
                    {assessmentDetails?.subject_id?.name}
                  </span>
                </div>

                {hideSelectBox ? null : (
                  <div className="hw_default_dropdown_card">
                    <small className="poppins-semibold">CHAPTER</small>
                    <select
                      id="bookChapterSelect"
                      className="hw_default_sub_dropdown_size form-select"
                      onChange={(e) => {
                        setLibraryQuestions([]);
                        setFilter((prev) => ({
                          ...prev,
                          bookChapter: {
                            bookId:
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("book-id"),
                            bookName:
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("book-name"),
                            chapterId: e.target.value,
                            chapterName:
                              e.target.options[e.target.selectedIndex].text,
                          },
                          page: 1,
                        }));
                      }}
                      value={filter?.bookChapter?.chapterId}
                    >
                      <option>Select Chapter</option>
                      {chapters?.length > 0 &&
                        chapters?.map((item) =>
                          item.bookInfo.map((book) => (
                            <optgroup
                              label={book.name}
                              key={book.id}
                              book-id={book.id}
                            >
                              {book.chapterData.map((chapter) => (
                                <option
                                  key={chapter.id}
                                  book-id={book.id}
                                  book-name={book.name}
                                  value={chapter.id}
                                >
                                  {chapter.chapterName}
                                </option>
                              ))}
                            </optgroup>
                          )),
                        )}
                    </select>
                  </div>
                )}
              </div>
              {hideSelectBox ? (
                <div
                  style={{
                    flex: "3",
                    width: "100%",
                    backgroundColor: "#fee3b8",
                  }}
                  className=""
                >
                  <small className="poppins-semibold">
                    SELECT QUESTION BANK
                  </small>
                  <select
                    onChange={(e) => {
                      setLibraryQuestions([]);
                      setFilter((prev) => ({
                        ...prev,
                        qsBankNameData: {
                          id: e.target.value,
                          name: e.target.options[e.target.selectedIndex].text,
                        },
                        page: 1,
                      }));
                    }}
                    // size="md"
                    // id="hello"
                    value={filter?.qsBankNameData?.id || ""}
                    className="form-select hw_default_sub_dropdown_size"
                  >
                    <option value="">Select Question Bank Name</option>
                    {QsBankNameList &&
                      QsBankNameList.length > 0 &&
                      QsBankNameList.map((qsName, index) => (
                        <option key={index} value={qsName?.id}>
                          {qsName?.name}
                        </option>
                      ))}
                  </select>
                </div>
              ) : (
                <div className="mt-2 d-flex gap-3 flex-wrap">
                  <div
                    style={{ flex: "3", backgroundColor: "#fee3b8" }}
                    className=""
                  >
                    <small className="poppins-semibold">DOMAIN</small>
                    <select
                      onChange={(e) => {
                        setLibraryQuestions([]);
                        setFilter((prev) => ({
                          ...prev,
                          domain: {
                            id: e.target.value,
                            name: e.target.options[e.target.selectedIndex].text,
                          },
                          page: 1,
                        }));
                      }}
                      // size="md"
                      // id="hello"
                      className="form-select hw_default_sub_dropdown_size"
                    >
                      <option value="">Select Knowledge Domain</option>
                      {domains &&
                        domains.length > 0 &&
                        domains.map((domain, index) => (
                          <option key={index} value={domain?.id}>
                            {domain?.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div style={{ flex: "3" }} className="">
                    <small className="poppins-semibold">SKILL</small>
                    <select
                      onChange={(e) => {
                        setLibraryQuestions([]);
                        setFilter((prev) => ({
                          ...prev,
                          skill: {
                            id: e.target.value,
                            name: e.target.options[e.target.selectedIndex].text,
                          },
                          page: 1,
                        }));
                      }}
                      // size="md"
                      // id="hello"
                      className="form-select hw_default_sub_dropdown_size"
                    >
                      <option value="">Select Skill</option>
                      {skills &&
                        skills.length > 0 &&
                        skills.map((skill, index) => (
                          <option key={index} value={skill.id}>
                            {skill.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div style={{ flex: "3" }} className="">
                    <small className="poppins-semibold">
                      LEVEL OF DIFFICULTY
                    </small>
                    <select
                      onChange={(e) => {
                        setLibraryQuestions([]);
                        setFilter((prev) => ({
                          ...prev,
                          difficultyLevel: {
                            id: e.target.value,
                            name: e.target.options[e.target.selectedIndex].text,
                          },
                          page: 1,
                        }));
                      }}
                      // size="md"
                      className="form-select hw_default_sub_dropdown_size"
                      // id="hello"
                    >
                      <option value="">Select Difficulty Level</option>
                      {difficultyLevels &&
                        difficultyLevels.length > 0 &&
                        difficultyLevels.map((difficultyLevel, index) => (
                          <option key={index} value={difficultyLevel?.id}>
                            {difficultyLevel?.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex  justify-content-between align-items-center px-3 mb-2">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      selectedQuestion.length === libraryQuestions.length &&
                      libraryQuestions.length > 0
                    }
                    indeterminate={
                      selectedQuestion.length > 0 &&
                      selectedQuestion.length < libraryQuestions.length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        libraryQuestions.forEach((q) => {
                          handleAddingQuestion(true, q); // 🔥 SAME FUNCTION
                        });
                      } else {
                        setSelectedQuestion([]);
                        setSelQueID([]);
                      }
                    }}
                  />
                }
                label="Select All Questions"
              />
            </div>
            <div
              id="total-assessment-library-question"
              className="mt-4 p-1 hw_library_box_conatainer flex-column"
            >
              <div className="d-flex hw_box_gap">
                <LibraryPropsBox
                  filter={filter}
                  setFilter={setFilter}
                  libraryQuestions={libraryQuestions}
                  setLibraryQuestions={setLibraryQuestions}
                  selectedQuestion={selectedQuestion}
                  setSelectedQuestion={setSelectedQuestion}
                  setSelQueID={setSelQueID}
                  selQueID={selQueID}
                  questions={questions}
                  getquestiondata={getquestiondata}
                  assessmentDetails={assessmentDetails}
                  sourceLibrary={sourceLibrary}
                  componentType={componentType}
                  setIsInProgress={setIsInProgress}
                  isInProgress={isInProgress}
                  setIsChecked={setIsChecked}
                  isChecked={isChecked}
                  hideSelectBox={hideSelectBox}
                  sourceQsBank={sourceQsBank}
                  qsBankNameData={qsBankNameData}
                  questionTypeMap={questionTypeMap}
                  setQuestionTypeMap={setQuestionTypeMap}
                  selectedBox={selectedBox}
                />
              </div>
            </div>

            <div className="mt-2 me-5 d-flex align-items-center justify-content-end">
              <button
                disabled={selectedQuestion.length < 1}
                className="btn library_next_btn"
                onClick={(e) => setClick(true)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      {click && (
        <OpenLibraryQuestion
          filter={filter}
          chaptersDataToPass={chaptersDataToPass}
          setClick1={setClick1}
          libraryQuestions={libraryQuestions}
          setQuestions={setQuestions}
          selectedQuestion={selectedQuestion}
          setClick={setClick}
          selQueID={selQueID}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          setOpenQuestionBox={setOpenQuestionBox}
          hideSelectBox={hideSelectBox}
        />
      )}
    </>
  );
};

export default SelectFromLibr;
